import classNames from "classnames";
import React from "react";

const QuarterGrid = ({ className, children, as: As = "div" }) => {
  return <As className={classNames("quarter-grid", className)}>{children}</As>;
};

export default QuarterGrid;
